import React from 'react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import { CardIcon } from '@ifpb/portal/components/CardIcon/CardIcon';
import cx from 'classnames';

const ServicosTemplate = (props) => {
  const { items, linkTitle, linkHref, isEditMode } = props;
  const columns = props?.columns ? props.columns : 'four';

  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';
  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  return (
    <>
      <div className={cx('items', `columns-${columns}`)}>
        {items.map((item) => {
          return (
            <div
              className={cx('listing-item', 'card-block', {
                [`${item['@type']?.toLowerCase()}-listing`]: item['@type'],
              })}
              key={item['@id']}
            >
              <ConditionalLink
                to={flattenToAppURL(item['@id'])}
                condition={!isEditMode}
              >
                <CardIcon
                  title={item.title}
                  icon={item.getIcon}
                  className={'card-block card-theme-default'}
                />
              </ConditionalLink>
            </div>
          );
        })}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

export default ServicosTemplate;
